import { View, User, Insight, FilterConfiguration, Aggregator,FilterSet } from './models'
import VueCookies from 'vue-cookies'

export const updateViews = (state, payload) => {
    let views = []

    payload.forEach(view => {
        // Exclude summary view
        if (view.firstTag != 'Summary') {
            views.push(new View(
                view.id,
                view.name,
                view.contentUrl,
                view.workbook.id,
                view.firstTag
            ))
        }
    })

    state.views = views
}

export const updateSummaryView = (state, payload) => {
    let summary = payload.filter(v => v.firstTag === 'Summary')[0]
    let summaryView = summary ? new View(
        summary.id,
        summary.name,
        summary.contentUrl,
        summary.workbook.id,
        summary.firstTag
    ) : null

    state.summaryView = summaryView
}

export const selectContent = (state, payload) => {
    state.selectedContent = payload
}

// Records which view was actually clicked when several views share the same urlName
export const setClickedViewId = (state, payload) => {
    state.clickedViewId = payload
}

export const updateConfiguration = (state, payload) => {
    state.configuration = payload
}

export const updateVizLoaded = (state, payload) => {
    state.vizLoaded = payload ? true : false
}

export const updateUser = (state, payload) => {
    state.user = new User(payload)
    
    // Extract feature flags from user payload if present and merge into state
    if (payload.featureFlags) {
        state.featureFlags = { ...state.featureFlags, ...payload.featureFlags };
    }
}

export const updateInsights = (state, payload) => {
    let insights = []

    payload.forEach(i => insights.push(new Insight(i)))

    state.insights = insights
}

export const getFilterListData = (state, payload) => {
    let filterList = []
    payload.forEach(i => filterList.push(new FilterConfiguration(i)))
    state.filterList = filterList
}

export const getAggregatorListData = (state, payload) => {
    let aggregatorList = []
    payload.forEach(i => aggregatorList.push(new Aggregator(i)))
    state.aggregatorList = aggregatorList
}

export const updateCookies = () => {
    VueCookies.set("cookies_consent", makeid(40), "1d");
}

export const getFilterSetList = (state, payload) => {
    let filterSetList = []
    payload.forEach(i => filterSetList.push(new FilterSet(i)))
    state.filterSetList = filterSetList    
}

function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export const setFeatureFlag = (state, { key, value }) => {
    state.featureFlags = { ...state.featureFlags, [key]: value };
};

export const setATPFeatureFlag = (state, { key, value }) => {
    state.featureFlags = { ...state.featureFlags, [key]: value };
};
